import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { content } from '../data/content';
import { PaintStroke } from './PaintStroke';
export function SignatureCallout() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-20%', '20%']);
  return <section ref={ref} className="relative py-24 md:py-32 overflow-hidden" data-id="element-234">
      {/* Sunset Bands Background */}
      <div className="absolute inset-0 flex flex-col" data-id="element-235">
        <div className="flex-1 bg-brand-amber" data-id="element-236" />
        <div className="flex-1 bg-brand-orange" data-id="element-237" />
        <div className="flex-1 bg-brand-tan" data-id="element-238" />
        <div className="flex-1 bg-brand-brown" data-id="element-239" />
      </div>

      {/* Texture Overlay */}
      <div className="absolute inset-0 opacity-10 mix-blend-overlay bg-[url('https://www.transparenttextures.com/patterns/stucco.png')]" data-id="element-240" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-241">
        <motion.div style={{
        y
      }} className="relative inline-block mb-8" data-id="element-242">
          <PaintStroke className="absolute -inset-x-8 -inset-y-4 w-[calc(100%+4rem)] h-[calc(100%+2rem)] text-brand-brown opacity-20 -z-10" data-id="element-243" />
          <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-brand-cream leading-tight" data-id="element-244">
            {content.signatureCallout.headline}
          </h2>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl md:text-2xl text-brand-cream/90 font-light max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-245">
          {content.signatureCallout.body}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="inline-block bg-brand-cream/10 backdrop-blur-sm border border-brand-cream/20 rounded-full px-6 py-3" data-id="element-246">
          <p className="text-brand-cream font-medium tracking-wide" data-id="element-247">
            {content.signatureCallout.specialty}
          </p>
        </motion.div>
      </div>
    </section>;
}